import React, { useState, useRef } from 'react';
import './ChangeEmailModal.css';
import Modal from '../Modal/Modal';
import ActionButtons from '../ActionButtons/ActionButtons';
import logComponent from '../../common/logComponent';


export default function ChangeEmailModal({ onChangeEmail, onCancelChangeEmail, isCurrentUser, hide }) {
  const [status, setStatus] = useState('initial');
  const [modalShouldExit, setModalShouldExit] = useState(false);
  const actionButtons = useRef(null);
  if (logComponent('ChangeEmailModal')) { console.debug('ChangeEmailModal rendered'); }

  let message = isCurrentUser
    ? 'Upon changing your email you will be automatically logged out and will log back in with your updated email address.'
    : 'Changing the email address of the user will require the user to log out and back in with the new email address';


  const changeEmail = () => {
    if (logComponent('ChangeEmailModal')) { console.debug('ChangeEmailModal changeEmail'); }
    onChangeEmail();
    startModalExit();
  }

  const cancelChangeEmail = () => {
    if (logComponent('ChangeEmailModal')) { console.debug('ChangeEmailModal cancelChangeEmail'); }
    onCancelChangeEmail();
    startModalExit();
  }


  const startModalExit = () => {
    if (logComponent('ChangeEmailModal')) { console.debug('ChangeEmailModal startModalExit'); }
    setModalShouldExit(true);
  }


  return (
    <Modal isVisible={true} shouldExit={modalShouldExit} hide={hide} remainOnBackdropClick={true}>
      <div className="Change-Email-Modal">
        <h3 className="Change-Email-Modal__heading">Change Email</h3>
        <p className="Change-Email-Modal__warning">Are you sure you want to change the email?</p>
        <p className="Change-Email-Modal__warning-explanation">{message}</p>
        <ActionButtons
          ref={actionButtons}
          warningAction={changeEmail}
          warningActionText="Yes, change email"
          cancel={cancelChangeEmail}
          cancelText="Cancel"
          currentStatus={status} />
      </div>
    </Modal>
  );
}